import { cn } from '@latitude/token-utils';
import * as AccordionPrimitive from '@radix-ui/react-accordion';
import type { ComponentPropsWithoutRef, ComponentRef, Ref } from 'react';
import { itemVariants } from 'variants/item-variants';

import { useAccordionContext } from '../AccordionContext';

/**
 * Represents an item in an accordion component.
 *
 * @component
 * @example
 * ```tsx
 * <AccordionItem>
 *   <AccordionTrigger/>
 *   <AccordionContent>Content goes here</AccordionContent>
 * </AccordionItem>
 * ```
 */
export const AccordionItem = ({
  className,
  ref,
  ...props
}: ComponentPropsWithoutRef<typeof AccordionPrimitive.Item> & {
  ref?: Ref<ComponentRef<typeof AccordionPrimitive.Item>>;
}) => {
  const context = useAccordionContext();
  return (
    <AccordionPrimitive.Item
      ref={ref}
      className={cn(
        itemVariants({ fill: context?.fill, grouped: context?.grouped }),
        className,
      )}
      {...props}
    />
  );
};

AccordionItem.displayName = 'AccordionItem';
